import { VInput } from 'vuetify/lib/components/VInput';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VInput,{attrs:{"rules":[_vm.recaptcha.recaptchaRules.required]},model:{value:(_vm.recaptcha.isSolved),callback:function ($$v) {_vm.$set(_vm.recaptcha, "isSolved", $$v)},expression:"recaptcha.isSolved"}},[_c('VueRecaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.sitekey,"loadRecaptchaScript":true},on:{"verify":_vm.onRecaptchaVerified,"expired":_vm.onRecaptchaExpired,"error":_vm.onRecaptchaError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }